import { ReactNode } from 'react'
import { Popover } from 'antd'
import styled from 'styled-components'
import { Text } from '@lmc/ui-kit/src/general'
import { useTranslation } from 'react-i18next'
import TeamMemberCard from './TeamMemberCard'

type TeamMembersPopoverProps = {
  children: ReactNode
  users?: any[]
}

const TeamMembersPopover = ({ children, users }: TeamMembersPopoverProps) => {
  const { t } = useTranslation()

  if (!users) return null

  return (
    <Popover
      placement="bottomRight"
      showArrow
      trigger="hover"
      arrow={{ pointAtCenter: true }}
      content={
        <Container>
          <Text weight="medium" level={2}>
            {t('TEAM_MEMBERS')}
          </Text>
          {users.map((user) => (
            <TeamMemberCard key={user.id} user={user} />
          ))}
        </Container>
      }
    >
      {children}
    </Popover>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 4px;
`

export default TeamMembersPopover
